<template>
  <div class="mg-t-20">
    <div
      v-if="tiltleTableFormReport.length !== 0 && tableDataValue.length != 0"
      class="is-flex js-between ai-center"
    >
      <p></p>
      <div class="is-flex">
        <b-button
          @click="csvExport"
          class="mg-5 button-light-green"
          icon-pack="fas"
          icon-left="download"
        >Export csv</b-button>
        <b-button
          @click="isListCheckTitle = true,columnsTemplate = defaultColumn"
          class="mg-5 button-light-green"
          icon-pack="fas"
          icon-left="cog"
        >Setting</b-button>
      </div>
    </div>
    <div
      v-if="tiltleTableFormReport.length === 0 || tableDataValue.length === 0"
      class="ai-center js-center is-flex is-flex-row m-h-auto"
    >
      <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">***</p>
      <p class="has-text-grey is-size-6 th is-padding-x has-text-centered">ขณะนี้ยังไม่มีข้อมูล Form</p>
      <p class="has-text-grey is-size-4 th is-padding-x-s is-margin-top-s">***</p>
    </div>
    <section v-else>
      <b-table
        :data="tableData"
        ref="multiSortTable"
        :bordered="true"
        :hoverable="true"
        :sort-multiple="true"
      >
        <template slot-scope="props">
          <b-table-column
            v-for="(column, index) in defaultColumn"
            :key="index"
            :field="column.field"
            :label="column.title+'('+(index+1)+')'"
            :visible="column.visible"
            sortable
          >
            <div v-if="props.row[column.field] !== null">
              <div v-if="column.type === 'file'">
                <p
                  v-if="typeof props.row[column.field][0] === 'undefined'"
                >{{props.row[column.field].name}}</p>
                <div v-else>
                  <p
                    v-for="(file,fileIndex) in props.row[column.field]"
                    :key="fileIndex"
                  >{{fileIndex+1}}. {{ file.name }}</p>
                </div>
              </div>
              <div v-else-if="column.type === 'checkbox'">
                <p v-for="(file,checkBoxIndex) in props.row[column.field]" :key="checkBoxIndex">
                  <span
                    v-if="typeof file.userValue === 'undefined' || file.userValue === false"
                  >{{checkBoxIndex+1}}. {{ file.label }}</span>
                  <span v-else>{{checkBoxIndex+1}}. {{ file.des }}</span>
                </p>
              </div>
              <p v-else>{{ props.row[column.field] }}</p>
            </div>
            <i v-else>ส่วนนี้ยังไม่มีข้อมูล Form</i>
          </b-table-column>
        </template>
      </b-table>
    </section>

    <b-modal :active.sync="isListCheckTitle" :width="900">
      <div class="card modalActivity">
        <div class="card-content">
          <div class="content">
            <div>
              <p class="is-size-3 th has-text-centered">ตั้งค่าตาราง</p>
              <p class="is-size-5 th has-text-centered">(กรุณาเลือก คอลัมน์ที่ต้องการแสดง)</p>
            </div>
            <div class="has-text-centered">
              <b-button
                class="mg-5"
                type="is-primary"
                icon-left="check"
                icon-pack="fas"
                @click="checkAll()"
              >
                <span>Check all</span>
              </b-button>
              <b-button
                class="mg-5"
                type="is-danger"
                icon-left="times"
                icon-pack="fas"
                @click="clearAll()"
              >
                <span>Clear check</span>
              </b-button>
            </div>
            <div class="th pd-y-4">
              <div
                v-for="(column, index) in columnsTemplate"
                :key="index"
                class="has-text-left pd-l-20 pd-y-5"
                @click="setStore"
              >
                <b-checkbox v-model="column.visible">{{ column.title +' ('+(index+1)+')'}}</b-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP, HTTPDynamic } from "@/service/axios";
export default {
  name: "ComponentReport",
  props: ["valueConst", "tiltleTableFormReport", "tableDataValue", "ownedId"],
  computed: {
    user() {
      return this.$store.state.user;
    },
    defaultColumn() {
      return this.$store.state.defaultColumn;
    }
  },
  data() {
    return {
      tableData: [],
      columnsTemplate: [],
      isListCheckTitle: false,
      urlFile: process.env.VUE_APP_URL_DYNAMIC
    };
  },
  mounted() {
    let title = this.setTitleAdd(
      this.tableDataValue,
      this.tiltleTableFormReport
    );
    let columns = this.tiltleTableFormReport.concat(title);

    if (this.defaultColumn.length == 0) {
      this.$store.commit("SET_COLUMN", columns);
      this.columnsTemplate = columns;
    } else {
      this.columnsTemplate = this.defaultColumn;
    }

    this.tableData = this.setValueData(
      this.tableDataValue,
      this.columnsTemplate
    );
  },
  watch: {
    tableDataValue() {
      let title = this.setTitleAdd(
        this.tableDataValue,
        this.tiltleTableFormReport
      );
      let columns = this.tiltleTableFormReport.concat(title);
      this.columnsTemplate = columns;

      this.tableData = this.setValueData(
        this.tableDataValue,
        this.columnsTemplate
      );
    }
  },
  methods: {
    setStore() {
      this.$store.commit("SET_COLUMN", this.columnsTemplate);
      setTimeout(() => {
        this.columnsTemplate = this.defaultColumn;
      }, 500);
    },
    setTitleAdd(valueData, column) {
      let title = [];

      valueData.map(item => {
        column.map(label => {
          if (label.visible === true) {
            let data = item.data[0].input;
            let dataForm = item.data[0].inputForm;
            let dataAdd = [];
            if (typeof dataForm != "undefined") {
              Object.keys(dataForm).forEach(key => {
                dataForm[key].map((item, index) => {
                  let haveField = title.filter(
                    filter =>
                      filter.field == key + "" + label.field + "" + index
                  );

                  if (
                    typeof data[key + "" + label.field + "" + index] !=
                      "undefined" &&
                    haveField.length == 0
                  ) {
                    let obj = {
                      field: key + "" + label.field + "" + index,
                      title: label.title + " ชุดที่ " + (index + 2),
                      type: label.type,
                      visible: label.visible
                    };
                    title.push(obj);
                  }
                });
              });
            }
          }
        });
      });
      return title;
    },
    setValueData(valueData, column, type) {
      let value = [];
      let obj = {};
      valueData.map(item => {
        column.map(label => {
          if (label.visible === true) {
            let data = item.data[0].input;
            let input = null;

            if (
              typeof data[label.field] !== "undefined" &&
              data[label.field] !== null &&
              data[label.field] !== "" &&
              data[label.field].length !== 0
            ) {
              if (label.type == "date") {
                if (data[label.field] != null) {
                  if (type == "csv") {
                    input =
                      '"' +
                      this.$options.filters.dateFomatShortmonth(
                        data[label.field]
                      ) +
                      '"';
                  } else {
                    input = this.$options.filters.dateFomatShortmonth(
                      data[label.field]
                    );
                  }
                }
                obj[label.field] = input;
              } else if (label.type === "select") {
                if (type == "csv") {
                  input = '"' + data[label.field] + '"';
                } else {
                  input =
                    typeof data[label.field].phoneNumber !== "undefined"
                      ? data[label.field].phoneNumber
                      : data[label.field].label;
                }
                obj[label.field] = data[label.field].value;
              } else if (label.type === "radio") {
                if (data[label.field].data !== null) {
                  if (type == "csv") {
                    input = '"' + data[label.field] + '"';
                  } else {
                    input =
                      typeof data[label.field].data !== "undefined" &&
                      data[label.field].data.userValue === true
                        ? data[label.field].des
                        : data[label.field].data.label;
                  }

                  // obj[label.field] = input
                  obj[label.field] = data[label.field].data.label;
                } else {
                  obj[label.field] = null;
                }
              } else if (label.type === "file") {
                if (type == "csv") {
                  let str = "";
                  let userId =
                    typeof this.$route.params.roleId !== "undefined" &&
                    this.$route.params.roleId !== ""
                      ? this.$route.params.roleId
                      : this.user._id;
                  if (typeof data[label.field][0] === "undefined") {
                    if (typeof data[label.field].name !== "undefined") {
                      if (type == "csv") {
                        str =
                          '=HYPERLINK("' +
                          this.urlFile +
                          userId +
                          "/" +
                          data[label.field].name +
                          '")';
                      }
                    } else {
                      str = "";
                    }
                  } else {
                    for (
                      let index = 0;
                      index < data[label.field].length;
                      index++
                    ) {
                      let text =
                        this.urlFile +
                        userId +
                        "/" +
                        data[label.field].name +
                        ", ";
                      str += text;
                    }
                  }
                  input = '"' + str + '"';
                } else {
                  input = data[label.field];
                }

                obj[label.field] = input;
              } else if (label.type === "checkbox") {
                if (data[label.field].data !== null) {
                  let str = "";
                  for (
                    let index = 0;
                    index < data[label.field].length;
                    index++
                  ) {
                    let text = "";
                    if (
                      typeof data[label.field].userValue === "undefined" ||
                      data[label.field].userValue === false
                    ) {
                      text =
                        index + 1 + ". " + data[label.field][index].label + " ";
                    } else {
                      text =
                        index + 1 + ". " + data[label.field][index].des + " ";
                    }

                    str += text;
                  }

                  if (type == "csv") {
                    input = '"' + str + '"';
                  } else {
                    input = data[label.field];
                  }

                  obj[label.field] = input;
                } else {
                  obj[label.field] = null;
                }
              } else {
                if (type == "csv") {
                  input =
                    '="' + data[label.field].replace(/#|,|-|\n/g, "") + '"';
                } else {
                  input = data[label.field];
                }

                obj[label.field] = input;
              }
              // if (typeof data[label.field]==='object'){
              //     if(data[label.field].value){
              //         obj[label.field] = data[label.field].value
              //     }else if(data[label.field].data){
              //         obj[label.field] = data[label.field].data.label //radio
              //     }else{
              //         obj[label.field] = data[label.field].data
              //     }
              // }else{

              // }
            } else {
              obj[label.field] = null;
            }
          }
        });

        value.push(obj);
        obj = {};
      });

      return value;
    },
    csvExport() {
      let data = this.setValueData(
        this.valueConst,
        this.columnsTemplate,
        "csv"
      );
      let file =
        "Report_" +
        new Date().getDate() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getFullYear() +
        "_" +
        new Date().getHours() +
        "-" +
        new Date().getMinutes() +
        "-" +
        new Date().getSeconds();

      let title = [];
      for (let index = 0; index < this.columnsTemplate.length; index++) {
        if (this.columnsTemplate[index].visible === true) {
          title.push(this.columnsTemplate[index].title);
        }
      }

      let csvContent = "";
      csvContent += [
        title.join(","),
        ...data.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      var link = window.document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );
      link.setAttribute("download", file + ".csv");
      link.click();
    },

    checkAll() {
      for (var i = 0; i < this.columnsTemplate.length; i++) {
        this.columnsTemplate[i].visible = true;
      }
      this.$store.commit("SET_COLUMN", this.columnsTemplate);
    },
    clearAll() {
      for (var i = 0; i < this.columnsTemplate.length; i++) {
        this.columnsTemplate[i].visible = false;
      }
      this.$store.commit("SET_COLUMN", this.columnsTemplate);
    }
  }
};
</script>
<style scoped>
section {
  overflow-x: auto !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.b-table .table th {
  font-weight: 400 !important;
}
.b-table .table {
  border-radius: 0px !important;
}
i {
  color: #ccc;
  font-weight: 200;
}
th {
  font-weight: 500 !important;
}
td {
  min-width: 100px !important;
}
a {
  color: #6d8df3;
}
.mg-t-empty {
  margin-top: 150px !important;
}
</style>
